// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Word_inputWrapper__Jbsni","firstWord":"Word_firstWord__WMM6J"};